import React, { useState } from "react"
import NextImg from "@/common/components/NextImg"
import styled from "styled-components"
import Title from "@/containers/MoneyFortune/View/homeWEB3/Title"
import StartButton from "./Button"
import LOGO from "@/common/assets/image/moneyFortune/web3Plus/web3LOGO.svg"

import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight"
import mainBG from "@/common/assets/image/moneyFortune/web3Plus/main_bg.webp"
import mainBall from "@/common/assets/image/moneyFortune/web3Plus/ball.webp"

export default function Home({ page, setPage }) {
  const [homeAnimation, SetHomeAnimation] = useState(false)

  const start = () => {
    setTimeout(() => setPage(2), 3000)

    SetHomeAnimation(true)
  }

  return (
    <Wrapper className={homeAnimation === true && "active"}>
      <BG>
        <BGFirstWrapper className="BGFirst">
          <NextImg src={mainBG} />
        </BGFirstWrapper>
      </BG>
      <ContentWrapper>
        <TitleWrapper className="ContentTitle">
          <Title
            title0="Mamamia!"
            title1="區塊鏈的"
            title2="多重宇宙"
            title3="你會是哪"
            title4="個星球人"
            desc="免費領取 NFT"
          />
        </TitleWrapper>
      </ContentWrapper>
      <Foreground className="Foreground">
        <BallWrapper>
          <NextImg src={mainBall} />
        </BallWrapper>
        <Floor>
          <p>Powered by KryptoGO</p>
        </Floor>
        <FloorUnderground />
      </Foreground>
      <StartButtonWrapper className="ContentBtn">
        {/* <StartButton content="START" onClick={start} /> */}
        <StartButton
          content={
            <>
              開始測驗 <KeyboardArrowRightIcon />
            </>
          }
          onClick={start}
        />
      </StartButtonWrapper>
      <LogoWrapper className="LOGO">
        <NextImg src={LOGO} />
      </LogoWrapper>
      <FilterBG />
    </Wrapper>
  )
}

const Wrapper = styled.div`
  width: 100%;
  height: var(--vh);
  background-color: #040927;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: flex-end;
  overflow: hidden;
  @media (max-width: 768px) {
  }

  &.active {
    .BGFirst {
      img {
        transform: translate(0, -30vh);
      }
    }
    .BGBuilding {
      transform: translate(0, -60vh);
    }
    .BGOthers {
      transform: translate(0, -80vh);
    }
    .ContentTitle {
      transform: translate(0, -80vh);
    }
    .ContentBtn {
      transform: translate(0, -30vh);
      opacity: 0;
      animation: none;
    }
    .LOGO {
      opacity: 0;
    }
    .Foreground {
      transform: translate(0, -100vh);
    }
  }
`

const FilterBG = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: var(--vh);
  background-color: #000000;
  z-index: 3;
  opacity: 1;
  animation: startBG 2s ease forwards;
  @keyframes startBG {
    0% {
      opacity: 1;
      display: block;
    }
    99% {
      opacity: 0;
      display: block;
      width: 100%;
      height: 100vh;
    }
    100% {
      display: none;
      opacity: 0;
      width: 0;
      height: 0;
    }
  }
`

const BGFirstWrapper = styled.div`
  width: 100%;
  position: absolute;
  will-change: transform;
  top: 50%;
  transform: translate(-50%, -50%);
  left: 50%;
  transition: all 3s;
  img {
    transition: all 3s;
  }
  @media (max-width: 768px) {
    transform: translate(-50%, -30%);
  }
`

const BallWrapper = styled.div`
  width: 150px;
  position: absolute;
  will-change: transform;
  z-index: 3;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  overflow: visible;
  span {
    animation: StartPeople 1.5s ease forwards;
    overflow: visible;
  }

  @keyframes StartPeople {
    0% {
      scale: 2;
    }
  }

  @media (max-width: 768px) {
    width: 100px;
    transform: translate(-50%, 10%);
  }
`

const BG = styled.div`
  width: 100%;
  height: 100vh;
  min-width: 1400px;
  position: absolute;
  z-index: 0;
  @media (max-width: 768px) {
    min-width: 1200px;
  }
`
const ContentWrapper = styled.div`
  width: 100%;
  height: 100%;
  position: absolute;
  will-change: transform;

  z-index: 2;
  display: flex;
  justify-content: center;
  align-items: center;
  animation: startContent 3s ease forwards;

  @keyframes startContent {
    0% {
      opacity: 0;
    }
    50% {
      opacity: 0;
      transform: translate(0, -5%);
    }
  }

  @media (max-width: 768px) {
    top: -5%;
  }
`

const Floor = styled.div`
  width: 100%;
  height: 50px;
  background: #4646f5;
  position: absolute;
  bottom: 0;
  display: flex;
  justify-content: end;
  align-items: center;
  p {
    text-align: right;
    padding: 20px;
    margin: 0 auto;
    width: clamp(0px, 100%, 1400px);
    @media (max-width: 768px) {
      text-align: center;
    }
  }
`
const FloorUnderground = styled.div`
  position: absolute;
  bottom: calc(-100vh);
  width: 100%;
  height: 100vh;
  background-color: #000;
`

const TitleWrapper = styled.div`
  margin-bottom: 150px;
  display: flex;
  width: 95%;
  max-width: 1000px;
  flex-direction: column;
  transition: all 3s;
  align-items: flex-end;
  position: relative;
  padding: 20px;
  @media (max-width: 768px) {
    margin-bottom: 25vh;
  }
`

const LogoWrapper = styled.div`
  width: 250px;
  position: absolute;
  z-index: 3;
  transition: all 3s;
  top: 40px;
  left: 50%;
  transform: translate(-50%, 0);
  @media (max-width: 1000px) {
    top: 80px;
    width: 200px;
  }
`

const Foreground = styled.div`
  width: 100%;
  height: 100vh;
  position: relative;
  display: flex;
  justify-content: center;
  transition: all 3s;
  align-items: center;
  z-index: 3;
`

const StartButtonWrapper = styled.div`
  width: 250px;
  transition: all 1s;
  position: absolute;
  bottom: 80px;
  div {
    animation: bigsmall 2s ease infinite;
  }
  z-index: 3;

  @media (max-width: 768px) {
    width: 300px;
    top: auto;
    bottom: 60px;
    h1 {
      font-size: 20px;
    }
  }
  @keyframes bigsmall {
    50% {
      transform: scale(1.05);
    }
  }
`
